let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2akqQ")).then(() => parcelRequire('9fM41'));